import "../chunk-PKUHTIDK.js";
const handleClick = ({ emit, props, state }) => (event) => {
  if (props.nativeType === "button" && props.resetTime > 0) {
    state.disabled = true;
    state.timer = setTimeout(() => {
      state.disabled = false;
    }, props.resetTime);
  }
  emit("click", event);
};
const clearTimer = (state) => () => clearTimeout(state.timer);
export {
  clearTimer,
  handleClick
};
